import { GAL_DEL, GAL_DETAILS, GAL_LIKE, GAL_LIST, GAL_SAVE } from "../actions/action-types";
import { initalState, initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Liste les images de la gallerie
export function GetGallerieReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case GAL_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détails d'une gallerie
export function GetDetailGallerieReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case GAL_DETAILS:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Ajouter une gallerie
export function SaveGallerieReducer(state = initalState, action) {
    switch (action.type) {
        case GAL_SAVE:
            return {
                alert: action.payload.alert,
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Supprimer une gallerie
export function DelGallerieReducer(state = initalState, action) {
    switch(action.type) {
        case GAL_DEL:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Mettre un like sur une gallerie
export function LikeGallerieReducer(state = initialStateNext, action) {
    switch (action.type) {
        case GAL_LIKE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}